import { memo } from 'react'
import { observer } from 'mobx-react'
import useVoucherBanner from './hooks/useVoucherBanner'
import TopNotActivatedVoucherBanner from './components/TopNotActivatedVoucherBanner'
import TopActivatedVoucherBanner from './components/TopActivatedVoucherBanner'

const VoucherBanner = () => {
  const {
    isVoucherBannerVisible,
    shouldShowTopActivationPromptBanner,
    shouldShowTopActivatedVoucherBanner,
    voucherBannerVariant
  } = useVoucherBanner()

  if (!isVoucherBannerVisible) {
    return null
  }

  if (shouldShowTopActivationPromptBanner) {
    return <TopNotActivatedVoucherBanner variant={voucherBannerVariant} />
  }

  if (shouldShowTopActivatedVoucherBanner) {
    return <TopActivatedVoucherBanner variant={voucherBannerVariant} />
  }

  return null
}

export default memo(observer(VoucherBanner))
